import { InjectionToken } from '@angular/core';

export const EUROGARD_TABLE_FILTER_FORM_DEFINITION = new InjectionToken('table-system/filter-form-definition');
